import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import PanelLayout from '../panel/layout';
import Const from '../../config/const';
import Color from '../color';
import CustomImage from '../custom_image';
// import WallPaper from '../wall_paper';
import * as classes from './classes.module.scss';

const TABS = {
  'Paint Colors': Color,
  // wallpaper: WallPaper,
  'Upload Your Own Background': CustomImage
};

export default class AddOther extends PureComponent {
  static propTypes = {
    closePanel: PropTypes.func.isRequired,
    hasCustomImage: PropTypes.bool.isRequired,
    hasWallPaper: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    const { hasCustomImage /* , hasWallPaper */ } = props;
    // eslint-disable-next-line no-nested-ternary
    const activeItemIndex = hasCustomImage ? 1 : 0;
    const activeItem = Object.keys(TABS)[activeItemIndex];
    this.state = {
      activeItem
    };
  }

  closePanel = () => {
    const { closePanel } = this.props;
    closePanel(Const.panelKinds.other);
  }

  changeTab = (_, { name }) => this.setState({ activeItem: name });

  render() {
    const { activeItem } = this.state;

    const tabs = Object.keys(TABS).map((t) => (
      <Menu.Item name={ t } active={ activeItem === t } onClick={ this.changeTab } key={ t } />
    ));

    const C = TABS[activeItem];

    return (
      <PanelLayout onClose={ this.closePanel } title="Background">
        <div className={ classes.container }>
          <div className={ classes.filters }>
            <Menu pointing secondary>
              { tabs }
            </Menu>
          </div>
          <div className={ classes.holder }>
            <div className={ classes.scroll }>
              <C />
            </div>
          </div>
        </div>
      </PanelLayout>
    );
  }
}
